if (!customElements.get('rl-science-research')) {
    customElements.define('rl-science-research', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        const panel = this.querySelector('[role="region"]');
        let pinned = false;
        const close = (returnFocus = false) => {
          pinned = false;
          details.open = false;
          if (returnFocus) summary.focus();
        };

        summary.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' && matchMedia('(hover: hover)').matches) details.open = true;
        }, options);
        this.addEventListener('pointerleave', () => {
          if (!pinned && !this.contains(document.activeElement)) close();
        }, options);
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          pinned = !pinned;
          details.open = pinned;
        }, options);
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget) && !this.matches(':hover')) close();
        }, options);
        this.querySelector('button').addEventListener('click', () => close(true), options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) close();
        }, options);
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && details.open) {
            event.preventDefault();
            close(panel.contains(document.activeElement));
          }
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
